import { useState, useEffect, useCallback } from 'react';
import { throttle } from '@thd-olt-functional/utils';

import { isInView } from '../utils';

export const useOnScreen = (refs) => {
  const [intersectedRefIndex, setIntersectedRefIndex] = useState(null);

  const onScrollHandler = useCallback(throttle(10, () => {
    refs.forEach((ref, index) => {
      if (isInView(ref.current)) {
        setIntersectedRefIndex(index);
      }
    });
  }), [intersectedRefIndex, setIntersectedRefIndex, refs]);

  useEffect(() => {
    onScrollHandler();
    window.addEventListener('scroll', onScrollHandler);
    return () => {
      window.removeEventListener('scroll', onScrollHandler);
    };
  }, [onScrollHandler, refs]);

  return { intersectedRefIndex };
};
